import { CountrySettings } from 'api/general-countries';
import { Country } from './business-keywords';
import { UserContact } from './business-types';

export interface CountryPair {
  country: Country;
  settings: CountrySettings;
}

export interface EmailAddressWrapper {
  emailAddress: string | null;
}

export interface SystemUserWrapper {
  user: UserContact | null;
  userId: number | null;
}

export interface SystemUserContactWrapper extends SystemUserWrapper {
  countriesContactEmail: string | null;
}

export interface CountryWrapper {
  country: Country | null;
}
